(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaDosageDeleteController',RcopiaDosageDeleteController);

    RcopiaDosageDeleteController.$inject = ['$uibModalInstance', 'entity', 'RcopiaDosage'];

    function RcopiaDosageDeleteController($uibModalInstance, entity, RcopiaDosage) {
        var vm = this;

        vm.rcopiaDosage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RcopiaDosage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
